import { render, staticRenderFns } from "./AccountDeletion.vue?vue&type=template&id=11229ae1&scoped=true&"
import script from "./AccountDeletion.vue?vue&type=script&lang=js&"
export * from "./AccountDeletion.vue?vue&type=script&lang=js&"
import style0 from "./AccountDeletion.vue?vue&type=style&index=0&id=11229ae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11229ae1",
  null
  
)

export default component.exports